module.exports = __webpack_public_path__ + "static/MonoramaMedium-6e4d14f8c395f2a5d0479652a197f5e2.woff";